import { FC, HTMLAttributes } from "react";
import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { Avatar, PresenceIndicator } from "@benefit-systems/hr-tools-ui";
import { IEmployeeDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import __ from "src/utils/Translations";

interface IEmployeesAutocompleteOptionProps {
  liProps: HTMLAttributes<HTMLLIElement> & {
    key: unknown;
  };
  option: IEmployeeDetails;
  showInactiveLabel?: boolean;
}

const EmployeesAutocompleteOption: FC<IEmployeesAutocompleteOptionProps> = ({
  liProps,
  option,
  showInactiveLabel = false,
}) => (
  <ListItem
    {...liProps}
    key={option.employeeId}
    alignItems="center"
    secondaryAction={
      showInactiveLabel && !option.active ? (
        <Typography variant="body2" color="textSecondary">
          {__("Nieaktywny")}
        </Typography>
      ) : null
    }
    sx={{ display: "flex", alignItems: "center", paddingY: "6px" }}
  >
    <ListItemAvatar>
      <PresenceIndicator status={option.presenceStatus}>
        <Avatar src={option.avatarUrl} alt="avatar">
          {option.initials}
        </Avatar>
      </PresenceIndicator>
    </ListItemAvatar>
    <ListItemText
      sx={{ ml: 1 }}
      primary={
        <Typography
          variant="body1"
          sx={{ fontWeight: 700, fontSize: "0.875rem" }}
        >
          {`${option.firstName} ${option.lastName}`}
        </Typography>
      }
      secondary={
        <>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "0.75rem" }}
          >
            {option.position || __("Brak stanowiska")}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "0.75rem" }}
          >
            {__("Numer pracownika")}: {option.fkNumber}
          </Typography>
        </>
      }
    />
  </ListItem>
);

export default EmployeesAutocompleteOption;
